import { createAxiosClient } from '@/utils/axios/createAxiosClient';
import { getUTMHeaders } from '@/utils/axios/utm-headers';
import getEnv from '@/env';

export const DealsDashboardClient = createAxiosClient({
  options: {
    baseURL: getEnv().deals_dashboard_service_url,
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 300000,
  },
});

DealsDashboardClient.interceptors.request.use((config) => {
  Object.entries(getUTMHeaders()).forEach(([name, value]) => {
    config.headers.set(name, value);
  });

  return config;
});
